import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

/**
 * LinkParsePipe
 * --------------
 * Purpose:
 *   Normalize arbitrary CMS strings into absolute app paths for routing.
 *
 * Behavior:
 *   - Empty/null/undefined → "/"
 *   - Explicit schemes (http, https, mailto, tel, ftp, data, …) → returned unchanged
 *   - Everything else → internal path normalized to exactly one leading slash
 *       e.g. "zomer" -> "/zomer", "///zomer" -> "/zomer", "//cdn.example.com/x" -> "/cdn.example.com/x"
 *
 * Notes:
 *   - Only use this for internal navigation if you're binding to [routerLink].
 *     Passing external URLs (e.g. "https://…") to [routerLink] will not work.
 *     For external links, bind to [href] instead.
 */
export function parseLink(value?: string | null): string {
	const raw = (value ?? '').trim();
	if (!raw) {
		return '/';
	}

	if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw)) {
		return raw;
	}

	return '/' + raw.replace(/^\/+/, '');
}

@Pipe({
	name: 'linkparse',
	pure: true,
})
export class LinkParsePipe implements PipeTransform {
	transform(value?: string | null): string {
		return parseLink(value);
	}
}
